<style>
    .fv-ivu-tabs-card {
        float: left;
        width: 30%;
        height:100%;
    }
    .fv-ivu-modal-Tagfooter {
        float: left;
        width: 50%;
        height:100%;
    }
    .fv-ivu-modal-footer {
        float: left;
        width: 20%;
        height:100%;
    }

    .fv-ivu-modal-footer .ivu-table{
        width: 100%;
    }

    .fv-ivu-modal-Tagfooter .ivu-table{
        width: 100%;
    }
    .fv-ivu-variable-Tagfooter {
        float: left;
        width: 70%;
        height:100%;
    }
    .fv-ivu-variable-footer {
        float: left;
        width: 50%;
        height:100%;
    }

    .fv-ivu-variable-footer .ivu-table{
        width: 100%;
    }

    .fv-ivu-variable-Tagfooter .ivu-table{
        width: 100%;
    }
    .fv-ivu-tabs-card{
        border: 1px solid #dcdee2;
    }
    .page2{
        position: absolute;
        left: 35%;
        top: 82%;
    }
    /*设置窗层级*/
    .tagsZindex .ivu-modal-wrap{
        z-index: 9999 !important;
    }
</style>

<template>
<div>
    <Modal
        v-model="isShow"
        :title="spotSelection.title" 
        draggable
        transfer
        :z-index="2000"
        :mask-closable="false"
        :width="withT"
        @on-cancel="cancel"
        class="tagsZindex"
        >
        <div style="height:300px">
            <!-- 标签 -->
            <Tabs class="fv-ivu-tabs-card" type="card" @on-click="onTabs" >
                <TabPane v-if="isDataSource" :label="spotSelection.dataSpot" style="overflow-y: auto;height: 250px;">
                    <Tree :data="tagsData" @on-select-change="OnTreeChange"></Tree>
                </TabPane>
                <TabPane v-if="isMidVar" :label="spotSelection.variable" style="overflow-y: auto;height: 250px;">
                    <Tree :data="midVarType" @on-select-change="onMidVar" ></Tree>
                </TabPane>
            </Tabs>
            <!-- 数据库 列表 -->
            <Table 
                v-show="isBase" 
                :height="300" 
                size="small" 
                class="fv-ivu-modal-Tagfooter" 
                highlight-row ref="currentRowTable" 
                @on-current-change="onLibraryData" 
                :show-header="true" 
                :columns="variableInfo" 
                :data="libraryData">
            </Table>
            <!-- 参数 列表 -->
            <Table 
                v-show="isBase" 
                :height="300" 
                size="small" 
                class="fv-ivu-modal-footer" 
                highlight-row ref="currentRowTable" 
                @on-current-change="onAttribute" 
                :show-header="true" 
                :columns="tagbaceInfo" 
                :data="attribute">
            </Table>
            <!-- 数据库 分页 -->
            <template>
                <Page 
                    :style="page1"
                    v-show="isBase" 
                    :total="dataCount" 
                    size="small" 
                    :page-size="pageSize" 
                    @on-change="changepage" 
                    show-total/>
            </template>
            <!-- 中间变量 列表 -->
            <Table 
                v-show="isVariable" 
                :height="300" 
                size="small" 
                class="fv-ivu-variable-Tagfooter" 
                highlight-row ref="currentRowTable" 
                @on-current-change="onVariableData" 
                :show-header="true" 
                :columns="libraryInfo" 
                :data="variableData">
            </Table>
            <!-- 中间变量 分页 -->
            <template>
                <Page 
                    class="page2" 
                    v-show="isVariable" 
                    :total="dataCount2" 
                    size="small" 
                    :page-size="pageSize2" 
                    @on-change="changepage2" 
                    show-total/>
            </template>
            <!-- 筛选 -->
            <template>
                <div v-show="isBase" style="position: absolute;left:18px;top:395px;">
                    <Input v-model="screenName" :placeholder="spotSelection.screen" style="width:100px"/>
                    <Button @click="screen">FN</Button>
                    <Button @click="describe">FD</Button>
                </div>
            </template>
        </div> 
        <div slot="footer">
            <Button type="text" size="large" @click="onCancel">{{spotSelection.close}}</Button>
            <Button type="primary" size="large" @click="onOk">{{spotSelection.ok}}</Button>
        </div>
    </Modal>
    </div>
</template>

<script>
import Vue from 'vue';
import { locale, Page } from 'view-design';
import cn from 'view-design/dist/locale/zh-CN';
import en from 'view-design/dist/locale/en-US';
export default {
    name : "tagsDialog",
    mounted : function(){
        
        this.$store.registerModule(['system','tagsDialog'],{
            state : {
                $ : this
            }
        });
        this.spotSelectionList = {
            title:"点选择对话框",
            dataSpot:"数据库点",
            variable:"中间变量",
            screen:"筛选",
            ok:"确定",
            close:"取消"
        };
        this.spotSelection = JSON.parse(JSON.stringify(this.spotSelectionList));
        this.variableInfoList = [
            {
                title: '名称',
                align: 'center',
                key: 'name'
            },
            {
                title: '描述',
                key: 'desc'
            }
        ];
        this.variableInfo = JSON.parse(JSON.stringify(this.variableInfoList));
        this.libraryInfoList = [
            {
                title: '名称',
                align: 'center',
                key: 'name'
            },
            {
                title: '最大值',
                key: 'maxvalue'
            },
            {
                title: '最小值',
                key: 'minvalue'
            },
            {
                title: '值',
                key: 'firstvalue'
            }
        ];
        this.libraryInfo = JSON.parse(JSON.stringify(this.libraryInfoList));
        this.midVarTypeList =[{
            title: '参数',
            expand: true,
            children: [
                {
                    title: '实型',
                    style: "double",
                    expand: true
                },
                {
                    title: '整型',
                    style: 'type',
                    expand: true
                },{
                    title: '字符型',
                    style: 'string',
                    expand: true
                }
            ]
        }];
        this.midVarType = JSON.parse(JSON.stringify(this.midVarTypeList));
        //数据库数据表头
        this.variableInfoValueList = [
            {
                title: '名称',
                align: 'center',
                key: 'name'
            }
        ];
        this.variableInfoValue = JSON.parse(JSON.stringify(this.variableInfoValueList));
        //参数表头
        this.tagbaceInfoList = [
            {
                title: '参数',
                align: 'center',
                key: 'name'
            }
        ];
        this.tagbaceInfo = JSON.parse(JSON.stringify(this.tagbaceInfoList));
        if(this.$store.state.system.$.languageName== "ch"){
            locale(cn);
        }else{
            locale(en);
        }
    },
    data : function(){
        return {
            spotSelection : {},
            isBase : true,
            isExpand:false,
            isVariable :false,
            isShow : false,
            oldName : "",
            isMidVar : true,
            isDataSource : true,
            isLong : true,
            tagsData : [],
            tabSelect:"",//高亮选中名称
            //分页
            pageSize: 7,//每页显示多少条
            dataCount: 0,//总条数
            pageCurrent: 1,//当前页
            result:[],
            //分页2
            pageSize2: 7,//每页显示多少条
            dataCount2: 0,//总条数
            pageCurrent2: 1,//当前页
            //tree点击数据库点和中间变量刷新的数据
            variableInfo: [],
            //中间变量表头
            libraryInfo: [],
            //tree中间变量表格参数
            midVarType:[],
            //数据库数据表头
            variableInfoValue: [],
            libraryData : [],// 数据库数据
            variableData : [],//中间变量数据
            attribute : [],//参数数据 pv 等数据
            tagbaceInfo:[],
            parameter : "PV",
            spotData : "",
            rootNode : "",
            //pv赋值
            tagsDataChildren : "",
            spotDesc : "",
            tagConfig : "",
            screenName:"",//筛选
            withT:"800",
            page1:{
                position: "absolute",
                left: "35%",
                top: "82%"
            }
        }
    },
    methods: {
        /**
         * 点击模糊查询名称
         */
        screen(){
            if(this.screenName.value!=""){
                this.libraryData= [];
                for(var i = 0;i<this.data.length;i++){
                    //判断点名称
                    if(this.data[i].name.indexOf(this.screenName)>-1){
                        this.libraryData.push(this.data[i]);
                    }
                }
                //重新赋值总条数
                this.dataCount = this.libraryData.length;
            }
        },
        /**
         * 点击模糊查询点描述
         */
        describe(){
            if(this.screenName.value!=""){
                this.libraryData= [];
                for(var i = 0;i<this.data.length;i++){
                    //判断点描述
                    if(this.data[i].desc.indexOf(this.screenName)>-1){
                        this.libraryData.push(this.data[i]);
                    }
                }
                //重新赋值总条数
                this.dataCount = this.libraryData.length;
            }
        },
        /*
            参数：data ：返回当前点击的数据
            作用： 切换 实时数据库和中间变量
        */
        onTabs(number){
            if(number){
                this.isBase = false;
                this.isVariable = true;
            }else{
                this.isBase = true;
                this.isVariable = false;
            }
            
        },
        /*
            参数：data ：返回当前点击的数据
            作用：数据库点 列表点击事件
        */
        onLibraryData(data){
            this.spotData = data.name;
            this.spotDesc = data.desc;
        },
        /*
            参数：data ：返回当前点击的数据
            作用：中间变量 列表 点击事件
        */
        onVariableData(data){
            return data;
        },
        //用于递归数据，拼接当前路径
        sedataList(arrData,prent,url) {
            if(arrData.length > 0){
                for (var i = 0; i < arrData.length; i++) {
                    if(prent){
                        arrData[i]["url"] = url+"."+arrData[i].title;
                    }else{
                        arrData[i]["url"] = arrData[i].title;
                    }
                    if(arrData[i].children && arrData[i].children.length > 0){
                        this.sedataList(arrData[i].children,arrData[i].title,arrData[i].url);
                    };
                };   
            };
        },
        /*
            参数：data ：返回当前点击的数据
            作用：数据库点 点击事件
        */
        OnTreeChange(data){
            this.sedataList([this.tagsData[0]])
            if(data.length!=0){
                this.data = data[0].libraryData;//LastChildren
                var titleList = "";
                var rootName = "";
                var listData = function(tagsData){
                    for(var v in tagsData){
                        //判断点击的节点和遍历的节点是否一直如果一直 返回递归拼接的路径
                        if(tagsData[v].title==data[0].title && tagsData[v].nodeKey==data[0].nodeKey){
                            rootName = tagsData[v].url;
                            return;
                        }

                        listData(tagsData[v].children);
                        
                    }
                }
                //递归 查找当前点击的节点
                listData([this.tagsData[0]]);
                this.rootNode = rootName;
            }
            this.libraryData = [];
            if(this.data != null){
                this.dataCount = this.data.length;
                if(this.dataCount < this.pageSize){
                    var number = this.dataCount;
                }else{
                    var number = this.pageSize;
                }
                for (var i = 0; i < number; i++) {
                    this.libraryData.push(this.data[i]);
                }   
            }
        },
        /*
        根据点名称递归查找
        
        */
        recursion(data,current){
           var result=null;
           if(!data){
               return;
           }
           for(var i in data){
               if(result !==null){
                   break;
               }
               var item=data[i];
               if(item.title==current){
                   result=item;
                    break;
               }else if(item.children && item.children.length>0){
                result=this.recursion(item.children,current);
               }
           }
          return result;
        },
    
      


        /*
            参数：data ：返回当前点击的数据
            作用：中间变量点击事件
        */
        onMidVar(root, node, data){
           
            this.dbvr = [];
            var store =this.$store.state.system.$.midVar;
            if(data.length!=0){
                for( var i in store){
                    if(data[0].style==store[i].type){
                        this.dbvr.push(store[i]);
                    }
                }
            }
            this.variableData = [];
            this.dataCount2 = this.dbvr.length;
            if(this.dataCount2 < this.pageSize2){
                var number = this.dataCount2;
            }else{
                var number = this.pageSize2;
            }
            for (var i = 0; i < number; i++) {
                this.variableData.push(this.dbvr[i]);
            }   
        },
        /**
         * 作用：点击参数列表
         * 参数：选中参数
         */
        onAttribute(currentRow){
            this.parameter = currentRow.name;
        },
        // 多语言
        setMultilingual:function(){
            //添加点弹窗
            for(var j in this.spotSelectionList){
                var name = this.$store.state.system.$.getResource(this.spotSelectionList[j]);
                this.spotSelection[j] = name ? name : this.spotSelectionList[j];
            }
            for(var o in this.variableInfoList){
                var name = this.$store.state.system.$.getResource(this.variableInfoList[o].title);
                this.variableInfo[o].title = name ? name : this.variableInfoList[o].title;
            }
            //中间变量表头
            for(var k in this.libraryInfoList){
                var name = this.$store.state.system.$.getResource(this.libraryInfoList[k].title);
                
                this.libraryInfo[k].title = name ? name : this.libraryInfoList[k].title;
            }
            //tree中间变量表格参数
            var type = this.$store.state.system.$.getResource(this.midVarTypeList[0].title);
            this.midVarType[0].title = type ? type : this.midVarTypeList[0].title;
            //类型
            for(var x in this.midVarTypeList[0].children){
                var name = this.$store.state.system.$.getResource(this.midVarTypeList[0].children[x].title);
                this.midVarType[0].children[x].title = name ? name : this.midVarTypeList[0].children[x].title;
            }
            ////数据库数据表头
            var value = this.$store.state.system.$.getResource(this.variableInfoValueList[0].title)
            this.variableInfoValue[0].title = value ? value : this.variableInfoValueList[0].title;
            //参数表头
            var info = this.$store.state.system.$.getResource(this.tagbaceInfoList[0].title)
            this.tagbaceInfo[0].title = info ? info : this.tagbaceInfoList[0].title;
        },
        /*
        递归修改对象里相同的值
        */
        registerValue(data){
           var result=null;
           if(!data){
               return;
           }
           for(var i in data){
               if(result !==null){
                   break;
               }
               var item=data[i];
               
                if(this.isExpand==false){
                   item.expand=false
               }else{
                item.expand=true 
               }
              
              if(item.children && item.children.length>0){
                result=this.registerValue(item.children);
               }
           }
          return result;
        },
        /**
         * 作用：打开窗口调用 打开本窗口使用sytemApi
         */
        /**  弹出变量选择对话框。
        * intbDbOnly:
            0表示可以选择，所有的变量
            1表示只选择数据库内的变量,禁用中间变量
        * nType：
            所选变量的类型 int 0:"DESC",1:"INDEX",2:"NAME",3:"PV",4:"TIME"
        * trOldVarName：
            默认选中 string型，预留参数,可用于记录上次选择的变量名 "test.tag.pv"
        * 示例 ： VarSelect(0,3,"test.tag.pv");
        */
        show : function(oldName,isMidVar,isDataSource,isLong,resolve){
            this.setMultilingual();
            if(window.isApp()){
                this.withT = "100%";
                this.page1={
                    position: "absolute",
                    left: "20%",
                    top: "82%"
                }
            }
            if(oldName==""||oldName==null || oldName==undefined){
                return;
            }
            let str=oldName.substring(0,oldName.lastIndexOf("."));
            //最后一个点之后的内容
            this.tabSelect=str.substring(str.lastIndexOf(".") + 1, str.length);
            str=str.substring(0,str.lastIndexOf("."));
            str = str.substring(str.lastIndexOf(".") + 1, str.length);
            //第一个点之前的内容
            let textArr=[];
            textArr=oldName.split(".");
            textArr.pop();
            textArr.pop();
            this.oldName = oldName;
            this.isMidVar = isMidVar;
            this.isDataSource = isDataSource;
            this.isLong = isLong;
            this.isShow = true;
            this.resolve = resolve ? resolve : undefined;
            this.tagsData[0].expand=true;
            let result=this.recursion(this.tagsData[0].children,str);
            // if(result==null)return;
            if(result==null){
                 if(this.tagsData[0].libraryData!=="" && this.tagsData[0].libraryData!==null && this.tagsData[0].libraryData!==undefined){
                    this.libraryData=this.tagsData[0].libraryData;
                     for(let a of this.libraryData){
                        if(a.name==this.tabSelect){
                            this.$set(a, "_highlight", true);
                            this.onLibraryData(a);
                        }
                    }
                    this.$set(this.tagsData[0], "selected", true);
                    let rootsNode=[];
                    rootsNode.push(this.tagsData[0]);
                    this.OnTreeChange(rootsNode);
                }else{
                    return;
                }
            }else{
                 this.$set(result, "selected", true);
                // this.$set(result, "expand", true);
                // this.libraryData = result.libraryData;
                for(var i of result.libraryData){
                    if(i.name==this.tabSelect){
                        this.$set(i, "_highlight", true);
                        this.onLibraryData(i);
                    }
                }
                var resultArr=[];
                resultArr.push(result);
                this.OnTreeChange(resultArr);
                for(let a of this.tagsData[0].children){
                    if(a.title==textArr[0]){
                        a.expand=true;
                        if(a.children.length>0){
                            for(let b=1; b<textArr.length;b++){
                                let objSelect=this.recursion(a.children,textArr[b]);
                                this.$set(objSelect, "expand", true);
                            }
                        }
                    }
                }
            }
           
            
        },
        create(tagsData){
            //动态获取 pv参数
            var arr = [];
            this.name ={};
            this.tagsData = this.$store.state.system.$.tagsTreeData;
            this.tagConfig = this.$store.state.system.$.tagConfig;
            this.registerValue(this.tagsData);
            for(var k in this.tagConfig){
                if(tagsData != undefined){
                    if(k == tagsData){
                        arr.push({name:k,_highlight:true});
                    }else{
                        arr.push({name:k});
                    }
                }else{
                    if(k == "PV"){
                        arr.push({name:k,_highlight:true});
                    }else{
                        arr.push({name:k});
                    }
                }
            }
            //赋值给参数数据
            this.attribute = arr;
            //判断数据源无数据
            if(this.$store.state.system.$.tagsTreeData[0].children[0]== undefined){
                this.tagsDataChildren = "";
            }else{
                this.tagsDataChildren = this.$store.state.system.$.tagsTreeData[0].children[0].title;
            }
            
        },
        //确定按钮
        onOk : function(){
            if(this.rootNode==""||this.spotData==""){
                // this.$Message.error({
                //     content:'未选择点名称！'
                // });
                alert(this.$store.state.system.$.languageName == "ch" ?'未选择点名称！' : 'Point name not selected!');
                return;
            }
            //确定后拼接点名称
            let resultName=this.rootNode+"."+this.spotData+"."+this.parameter;
            resultName=resultName.substring(resultName.indexOf(".")+1,resultName.length)
            if(typeof this.resolve == "function"){
                this.resolve({
                   // name : this.tagsDataChildren+"."+this.rootNode+"."+this.spotData+"."+this.parameter,
                    name : resultName,
                    desc : this.spotDesc
                    });
                    
            }else{
                return {
                    //name : this.tagsDataChildren+"."+this.rootNode+"."+this.spotData+"."+this.parameter,
                    name : resultName,
                    desc : this.spotDesc
                };
            }
            this.isShow = false;
            this.libraryData = [];
        },
        cancel : function(){
            this.isShow = false;
            this.libraryData = [];
        },
        //关闭窗口
        onCancel : function(){
            this.isShow = false;
            this.libraryData = [];
            // if(typeof this.resolve == "function"){
            //     this.resolve();
            // }else{
            //     return;
            // }
        },
        /*
            index ：需要显示开始数据的index
            作用： 点击翻页
        */
        changepage(index) {
            //需要显示开始数据的index,(因为数据是从0开始的，页码是从1开始的，需要-1)
            var _start = (index - 1) * this.pageSize;
            //需要显示结束数据的index
            var _end = index * this.pageSize;
            //截取需要显示的数据
            this.libraryData = this.data.slice(_start, _end);
            //储存当前页
            this.pageCurrent = index;
        },
        //每页显示的数据条数
        _nowPageSize(index) {
            //实时获取当前需要显示的条数
            this.pageSize = index;
        },
        /*
            index ：需要显示开始数据的index
            作用： 点击翻页
        */
        changepage2(index) {
            //需要显示开始数据的index,(因为数据是从0开始的，页码是从1开始的，需要-1)
            var _start = (index - 1) * this.pageSize;
            //需要显示结束数据的index
            var _end = index * this.pageSize;
            //截取需要显示的数据
            this.variableData = this.dbvr.slice(_start, _end);
            //储存当前页
            this.pageCurrent = index;
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/system/tagsDialog.vue